require(["dojo/has", "dojo/_base/sniff"], function(has) {

	window.popup = function (URL, width, height, config) {
		var day = new Date();
		var id = day.getTime();
		var fleft = (screen.width - width) / 2;
		var ftop = (screen.height - height) / 2;

		var fenster = window.open(URL, id, config + ",scrollbars=1,statusbar=0,menubar=0,resizable=1,width="+width+",height="+height+",left="+fleft+",top="+ftop+"");

		if (fenster) {
			if(has("chrome")) {
				fenster.parent.blur();
			} else {
				fenster.focus();
			}
			return false;
		} else {
			return true;
		}
	}

	window.popup800 = function (URL) {
    return popup(URL, 800, 600, "toolbar=0,location=0");
  }

	window.popup1024 = function (URL) {
    return popup(URL, 1024, 750, "toolbar=0,location=0");
  }

	window.popupDetails = function (URL) {
    let config;
		if(has("ie")) {
			config = "toolbar=0,location=1";
		} else if (has("mozilla")) {
			config = "toolbar=1,location=0";
		} else if (has("opera")) {
			config = "toolbar=1,location=0";
		} else {
			config = "toolbar=1,location=1";
		}
		return popup(URL, 1024, 750, config);
	}

});
